export default __webpack_public_path__ + "static/media/nikhil2.dbb9bb51.jpg";